import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useFormState } from 'react-final-form';

import { Field } from '../forms/finalForm';
import renderField from '../forms/render/renderField';
import renderSelectField from '../forms/render/renderSelectField';
import { educationFields } from '../forms/constants/resumeFormFieldConstants';
import renderFileField from '../forms/render/renderFileField';
import { required } from '../forms/validators';
import InputSuggestion from './InputSuggestion';


const getRenderType = (type) => {
  switch (type) {
    case 'file': return renderFileField;
    case 'select': return renderSelectField;
    default: return renderField;
  }
};

const EducationFieldSet = ({
  onDelete,
  member,
  index,
  validateResume,
}) => {
  const [deleteAnimation, setDeleteAnimation] = useState(false);
  const [addEducationAnimation, setAddEducationAnimation] = useState(true);
  const { values } = useFormState({ subscription: { values: true } });
  const establishments = (values.education && values.education.establishments) || [];
  const establishment = establishments[index] || {};

  useEffect(() => {
    const timer = setTimeout(() => setAddEducationAnimation(false), 1000);
    return () => clearTimeout(timer);
  }, []);

  const handleDelete = () => {
    setDeleteAnimation(true);
    onDelete();
  };

  return (
    <div
      className={`
      resume-from-education-field-set
      ${deleteAnimation ? 'education-delete-animation' : ''}
      ${addEducationAnimation ? 'education-add-animation' : ''}
    `}
    >
      <button
        type="button"
        title="удалить заведение"
        className="resume-from-education-delete"
        onClick={handleDelete}
      >
        Удалить
      </button>
      {educationFields.establishment.map(field => (
        <div key={`${member}${field.name}`} className="education-field-wrapper">
          {field.type !== 'inputWithSuggestion'
            ? (
              <Field
                name={`${member}.${field.name}`}
                label={field.label}
                placeholder={field.placeholder}
                validate={field.required ? [validateResume(field.type), required]
                  : validateResume(field.type)}
                type={field.type}
                component={getRenderType(field.type)}
                options={field.options}
              />
            ) : (
              <InputSuggestion
                {...field}
                name={`${member}.${field.name}`}
                choiceIdName={`${member}.university_id`}
                value={establishment[field.name] || ''}
                validate={field.required ? [validateResume(field.type), required]
                  : validateResume(field.type)}
                idForRequest={establishment.university_id || null}
              />
            )}
        </div>
      ))}
    </div>
  );
};

EducationFieldSet.propTypes = {
  onDelete: PropTypes.func.isRequired,
  member: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  validateResume: PropTypes.func.isRequired,
};

export default EducationFieldSet;
